/**
 * SearchHeaderContainer component.
 */
import styled from 'styled-components';

/**
 * Styled search header container.
 */
const SearchHeaderContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
`;

export default SearchHeaderContainer;
